var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.427 8.85148L17.0111 2.5H15.6879L10.8392 8.0149L6.9666 2.5H2.5L8.35615 10.8395L2.5 17.5H3.82333L8.94364 11.6761L13.0334 17.5H17.5L11.4267 8.85148H11.427ZM9.61456 10.913L9.02121 10.0825L4.30014 3.47475H6.33269L10.1426 8.80746L10.736 9.63788L15.6885 16.5696H13.656L9.61456 10.9133V10.913Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.82a62273f98328e01d01fc9099bdd75c.svg";
export { ForwardRef as ReactComponent };